import { createBrowserRouter, redirect } from 'react-router';
import { StartupLoader } from './components/startup-loader';
import { Root, RootErrorBoundary } from './routes/root';
import { NotFound } from './routes/not-found';
import { AppShell, sessionLoader } from './routes/app-shell';
import { LoginPage, loginLoader } from './routes/login/login';
import { DashboardPage } from './routes/dashboard/overview';
import { ContactsPage, contactsLoader } from './routes/contacts/list';
import { ContactPage, contactLoader } from './routes/contacts/detail';
import { SegmentsPage, segmentsLoader } from './routes/segments/list';
import { SegmentPage, segmentLoader } from './routes/segments/detail';
import { AuditPage, auditLoader } from './routes/audit/list';
import { AnalyticsPage, analyticsLoader } from './routes/analytics/overview';
import { TemplatesPage, templatesLoader } from './routes/templates/list';
import { NewTemplatePage } from './routes/templates/new';
import { TemplatePage, templateLoader } from './routes/templates/detail';
import { StylesPage, stylesLoader } from './routes/templates/styles/list';
import { StylePage, styleLoader } from './routes/templates/styles/detail';
import { CampaignsPage, campaignsLoader } from './routes/campaigns/list';
import { NewCampaignPage, newCampaignLoader } from './routes/campaigns/new';
import { CampaignPage, campaignLoader } from './routes/campaigns/detail';
import { UsersPage, usersLoader } from './routes/users/list';
import { FlowsPage, flowsLoader } from './routes/flows/list';
import { NewFlowPage, newFlowLoader } from './routes/flows/new';
import { FlowPage, flowLoader } from './routes/flows/detail';

/**
 * Data-mode router: every page declares a loader that calls crm-api directly (see lib/api.ts).
 * The `app` layout loader is the auth gate (replaces the old Next middleware).
 */
export const router = createBrowserRouter([
  {
    path: '/',
    Component: Root,
    HydrateFallback: StartupLoader,
    ErrorBoundary: RootErrorBoundary,
    children: [
      { path: 'login', loader: loginLoader, Component: LoginPage },
      {
        id: 'app',
        loader: sessionLoader,
        Component: AppShell,
        children: [
          { index: true, loader: () => redirect('/dashboard') },
          { path: 'dashboard', Component: DashboardPage },
          { path: 'users', loader: usersLoader, Component: UsersPage },
          { path: 'contacts', loader: contactsLoader, Component: ContactsPage },
          { path: 'contacts/:id', loader: contactLoader, Component: ContactPage },
          { path: 'segments', loader: segmentsLoader, Component: SegmentsPage },
          { path: 'segments/:id', loader: segmentLoader, Component: SegmentPage },
          { path: 'audit', loader: auditLoader, Component: AuditPage },
          { path: 'analytics', loader: analyticsLoader, Component: AnalyticsPage },
          { path: 'templates', loader: templatesLoader, Component: TemplatesPage },
          { path: 'templates/new', Component: NewTemplatePage },
          { path: 'templates/styles', loader: stylesLoader, Component: StylesPage },
          { path: 'templates/styles/:id', loader: styleLoader, Component: StylePage },
          { path: 'templates/:id', loader: templateLoader, Component: TemplatePage },
          { path: 'campaigns', loader: campaignsLoader, Component: CampaignsPage },
          { path: 'campaigns/new', loader: newCampaignLoader, Component: NewCampaignPage },
          { path: 'campaigns/:id', loader: campaignLoader, Component: CampaignPage },
          { path: 'flows', loader: flowsLoader, Component: FlowsPage },
          { path: 'flows/new', loader: newFlowLoader, Component: NewFlowPage },
          { path: 'flows/:id', loader: flowLoader, Component: FlowPage },
        ],
      },
      { path: '*', Component: NotFound },
    ],
  },
]);
